













































import AuthActions from '@/store/actions/auth';
import { Vue, Component } from 'vue-property-decorator';
import {mapGetters,} from 'vuex';
import axios from 'axios';
import screenSizeMixin from "@/mixins/screen-size-mixin";

@Component({
    // should probably use mapState, having trouble getting mapState to work
    computed: {
        ...mapGetters(['isAuthenticated', 'isProfileLoaded', 'authStatus', 'getGroups']),
    },
    mixins:[screenSizeMixin],
})
export default class Navigation extends Vue {

    logout(){
        this.$store.dispatch(AuthActions.AUTH_LOGOUT).then(() => this.$router.push('/login'));
        localStorage.removeItem("holdTicket");
    }

    invalidateToken(){
        localStorage.setItem('user-token', 'invalid')
        axios.defaults.headers.common.Authorization = '';
    }
}
